import { COMPONENT_NAME as SELECT_GRID_COMPONENT_NAME, IMRSelectGridComponent } from './select-grid/select-grid.component'
import { COMPONENT_NAME as SELECT_GRID_POPUP_COMPONENT_NAME, IMRSelectGridPopupComponent } from './popup/select-grid.popup.component'
import { COMPONENT_NAME as SELECT_GRID_INPUT_FIELD_COMPONENT_NAME, IMRSelectGridInputFieldComponent } from './input-field/select-grid.input-field.component'

export const SELECT_GRID_MODULE_NAME = 'simax.common.select-grid'

const module = angular.module(SELECT_GRID_MODULE_NAME, [])

module.component(SELECT_GRID_COMPONENT_NAME, new IMRSelectGridComponent())
module.component(SELECT_GRID_POPUP_COMPONENT_NAME, new IMRSelectGridPopupComponent())
module.component(SELECT_GRID_INPUT_FIELD_COMPONENT_NAME, new IMRSelectGridInputFieldComponent())
